import { ApprovalState } from "../../models/Enums"

export enum ViewState {
	AwaitResponse = 'AwaitResponse',
	Ongoing = 'Ongoing',
	Declined = 'Declined',
	Withdrawn = 'Withdrawn',
	Done = 'Done',
	RequireAttachments = 'RequireAttachments',
	ApprovalUnderReview = 'ApprovalUnderReview',
	Mismatch = 'Mismatch',
	AgeRestriction = 'AgeRestriction'
}

export type OrderViewModel = {
	orderId: number,
	companyName: string,
	viewState: ViewState
}

export type FileViewModel = {
	type : FileType 
    fileName: string
    downloadUrlPath: string
}

export enum FileType {
    Attachment = 'Attachment',
    SignedDocument = 'SignedDocument',
}

export type OngoingViewModel = OrderViewModel & {
	approved: Date
	estimatedDeliveryDate: Date
	isIDD: boolean
	checkpointTypes: Array<string>
	canWithdraw: boolean
	canAttachFile: boolean
	canAttachAdditionalInformation: boolean
	instructions: string
	files: FileViewModel[]
	additionalInformation: string | null
}

export type DeclinedViewModel = OrderViewModel & {
	declined: Date
}

export type MismatchViewModel = OrderViewModel & {
	nationalId: string
}

export type AgeRestrictionViewModel = OrderViewModel & {
	nationalId: string
}

export type WithdrawnViewModel = OrderViewModel & {
	declined: Date
}

export type AwaitResponseViewModel = OrderViewModel & {
	individualFirstName: string
	files: FileViewModel[]
	canAttachFile: boolean
	instructions: string
	approval: {
		type: ApprovalState
		canAccept: boolean
	}
}

export type DoneViewModel = OrderViewModel & {
	availableTo: Date
}

export type ApprovalUnderReviewViewModel = OrderViewModel & {
	orderId: number
	companyName: string
	canWithdraw: boolean
	canAttachFile: boolean
	canAttachAdditionalInformation: boolean
	files: FileViewModel[]
	additionalInformation: string | null
	instructions: string
};

export type IndividualInformationViewModel = {
	individualFirstName: string
	individualLastName: string
	individualEmail: string
	individualPhoneNumber: string
	individualNationalId: string
}

export type ApprovableOrderViewModel = IndividualInformationViewModel & {
	orderId: number
	companyName: string
	isIDD: boolean
	checkpointTypes: Array<string>
	canAttachFile: boolean
	files: FileViewModel[]
	canAttachAdditionalInformation: boolean
	additionalInformation: string,
	instructions: string
	approval: {
		type: ApprovalState
		acceptanceMethod: AcceptanceMethod
		canAccept: boolean
	}
}

export type AcceptanceMethod = "Click" | "BankId" | "Scrive"